import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

export interface SearchUsersModel {
    emailAddress?: string;
    secondaryReference?: string;
    phoneNumber?: string;
    dateOfBirth?: string;
}

export interface UserSearchListModel {
    readonly userType: "Customer" | "Employee";
    readonly id: string;
    readonly firstName?: string;
    readonly lastName?: string;
    readonly mobilePhoneNumber?: string;
    readonly personalEmailAddress?: string;
    readonly workEmailAddress?: string;
    readonly dateOfBirth?: Date;
    readonly customerId: string;
    readonly customerName: string;
    readonly secondaryReference?: string;
    readonly registeredEmailAddress?: string;
}

export const parseUserModel = (model: ServerModelWithDateStrings<UserSearchListModel>) => {
    let dateOfBirth;
    if (model.dateOfBirth && !isNaN(Date.parse(model.dateOfBirth))) {
        dateOfBirth = new Date(model.dateOfBirth);
    }

    return {
        ...model,
        dateOfBirth
    };
};
